import { useEnvironmentConfiguration } from '@ori/environment';
import { useEffect } from 'react';

import { AB_TASTY_SCRIPT_URL, AB_TASTY_SCRIPT_IDS } from '../constants';
import { useAppConfig } from '../context';

/**
 * Returns the AB Tasty script id based on the tenant and environment.
 * Example of generated url - https://try.abtasty.com/d7969c131a7cd1e6eae1663545c12f7e.js
 * @param tenant
 * @param environment
 */
export const getScriptId = (tenant: string | undefined, environment: string | undefined) => {
  const key = tenant && environment ? `${tenant}_${environment}` : null;

  return key && AB_TASTY_SCRIPT_IDS[key] ? `${AB_TASTY_SCRIPT_URL}${AB_TASTY_SCRIPT_IDS[key]}.js` : null;
};

/**
 * Loads the AB Tasty script if the feature is enabled and have corresponding script with the current tenant and environment.
 */
export const useLoadAbTastyScript = () => {
  const { abTastyEnabled } = useAppConfig();
  const { environment, tenant } = useEnvironmentConfiguration();

  useEffect(() => {
    const scriptId = getScriptId(tenant, environment);

    if (abTastyEnabled && scriptId) {
      const script = document.createElement('script');
      script.src = scriptId;
      script.async = true;
      document.body.append(script);

      return () => script.remove();
    }

    return undefined;
  }, [abTastyEnabled, environment, tenant]);
};
